import { render } from "./UserDocuments.vue?vue&type=template&id=bc7e2f6a&scoped=true"
import script from "./UserDocuments.vue?vue&type=script&lang=js"
export * from "./UserDocuments.vue?vue&type=script&lang=js"

import "./UserDocuments.vue?vue&type=style&index=0&id=bc7e2f6a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bc7e2f6a"

export default script